import { CompanyComparison, LookupCondition, MainItem, RefundExample, RefundPolicy, RefundProcess } from '@/components/landing/LandingSections';

export const LandingContent = () => {
  return (
    <>
      <MainItem sectionId={'01'} className={'bg-gradient-to-b from-[#ffffff] to-[#EBEDFC]'} />
      <RefundProcess sectionId={'02'} className={'bg-[#E3E6FF]'} />
      <RefundPolicy sectionId={'03'} className={'bg-[#FFFFFF]'} />
      <CompanyComparison sectionId={'04'} className={'bg-[#22272B]'} />
      <LookupCondition sectionId={'05'} className={'bg-gradient-to-b from-[#7483FF] to-[#926AFF]'} />
      <RefundExample sectionId={'06'} className={'bg-[#22272B]'} />
    </>
  );
};
